import {AbstractLitElement} from "../abstract-lit.element";
import {html, PropertyValues} from "lit";
import {property} from "lit/decorators/property.js";
import type {FormControlNotification, IFormControl} from "@ha/formhandler";
import {customElement} from "lit/decorators/custom-element.js";
import {filter, takeUntil} from "rxjs";
import {repeat} from "lit/directives/repeat.js";
import {state} from "lit/decorators/state.js";

@customElement(`ha-field-errors`)
export class HaFieldErrorsComponent extends AbstractLitElement {

    @property({type: Object})
    public formField!: IFormControl<any>;

    @state()
    private _errors: string[] = [];

    protected willUpdate(changedProperties: PropertyValues): void {
        if (changedProperties.has(`formField`)) {
            this.formField!.event$.pipe(
                takeUntil((this._disconnected$)),
                filter((notification: FormControlNotification) => notification.formControl!.path === this.formField.path),
            ).subscribe(notification => this._errors = notification.formControl!.getValidationErrors().map(error => error.message));

            this.formField.validate();
        }
    }

    protected render(): unknown {
        return repeat(this._errors, error => error, error => html`
                    <div class="field-error">${error}</div>
            `
        );
    }

}